"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertHourTo12 = exports.hourToAmOrPm = exports.parseNumberFormCommas = exports.formatNumberWithCommas = void 0;
function formatNumberWithCommas(num) {
    return new Intl.NumberFormat('ko-KR').format(num);
}
exports.formatNumberWithCommas = formatNumberWithCommas;
function parseNumberFormCommas(numberString) {
    return parseInt(numberString.replace(/,/g, ''));
}
exports.parseNumberFormCommas = parseNumberFormCommas;
function hourToAmOrPm(hour) {
    return hour < 12 ? '오전' : '오후';
}
exports.hourToAmOrPm = hourToAmOrPm;
function convertHourTo12(hour) {
    if (hour > 12) {
        return hour - 12;
    }
    return hour;
}
exports.convertHourTo12 = convertHourTo12;
